import { Theme } from "./theme.model";
import { LonaciTheme } from "./theme_lonaci";
import { TunisiaTheme } from "./theme_tunisia";

// export interface PartnersInfo {
//   src: string;
//   width: number;
//   href: string;
//   title: string;
// }

// export interface ThemeSocialPartners {
//   socialMediaLinks: SocialMedia,
//   partners: Array<PartnersInfo>
// }

export const tunisia: Theme = TunisiaTheme;

export const lonaci: Theme = LonaciTheme

